export function DifferenzaBrandCapital() {
  const statistiche = [
    { numero: '100+', label: 'Indicatori Integrati' },
    { numero: '100%', label: 'Difendibile Legalmente' }, 
    { numero: '360°', label: 'Documentazione Completa' }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Box Centrale Evidenziato */}
        <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-3xl p-8 sm:p-12 lg:p-16 shadow-2xl">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6">
            Cosa Ci Differenzia
          </h2>
          
          <div className="w-16 h-0.5 bg-white mx-auto mb-8"></div>
          
          <p className="text-base sm:text-lg lg:text-xl text-white leading-relaxed">
            Mentre i nostri competitor utilizzano metodologie parziali e indicatori isolati, 
            <strong className="font-bold"> Brand Capital integra tutti gli indicatori esistenti</strong> in un'unica 
            metodologia scientifica. Creiamo perizie <strong className="font-bold">complete, tracciabili e 
            legalmente difendibili</strong>, supportate da documentazione exhaustiva e processi 
            certificati. La differenza non è solo nella precisione, ma nella <strong className="font-bold">certezza 
            assoluta</strong> che ogni nostra valutazione resisterà a qualsiasi controllo, 
            revisione o analisi futura.
          </p>
        </div>

        {/* Statistiche */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12 mt-12 lg:mt-16">
          {statistiche.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl sm:text-5xl font-bold text-slate-900 mb-2">
                {stat.numero}
              </div>
              <div className="text-sm sm:text-base text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}